import React, { useEffect, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import ConfirmationPopUp from '../../../common/ConfirmationPopUp'
import CancelBookingModal from '../../../common/CancellationPopUp'
import { BOOKING_STATUSES, NOTIFICATION_MESSAGE_TYPE } from '../../../constants'
import { cancelBooking } from '../../../services/manageBookingService'
import { getRecentBooking, getRussiaAttachmentDetails } from '../../../services/templateService'
import LoadingIndicator from '../../LoadingIndicator'
import CargoDetails from './CargoDetails'
import ChargeDetails from './ChargeDetails'
import './index.scss'
import { getBookingResponseMapper } from './ResponseMapper'
import WeightDetails from './WeightDetails'
import { useHistory } from 'react-router-dom'
import ShareEmailDialog from './ShareEmailDialog'
import { getAirportsByCode } from '../../../services/searchPanelServices'
import PrintBookingDialog from '../../../common/PrintBookingDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHourglassHalf } from '@fortawesome/free-solid-svg-icons'
import pendingIcon from '../../../assets/images/Pending_icon.svg'
import { handlePrint } from './printEmailUtil'
import MESSAGES from '../../../constants/Messages'
import BookingMenu from '../../BookingMenu'
import rejectIcon from '../../../assets/images/Error-Close-Filled.png'
import successIcon from '../../../assets/images/success-icon.png'
import toBeProcessedIcon from '../../../assets/images/errorFilledOrange.svg'
import moment from 'moment'
import { Alert } from '../../../common/Alert'
import { Trans, useTranslation } from 'react-i18next'
import editIcon from '../../../assets/images/edit.png'
import { addError, pushPageData } from '../../../utils/analytics'
import pageNames from '../../../constants/pageNames'
import { PAGE_PRIMARY_CATEGORY, PAGE_SUB_CATEGORY1, BOOKING_PAGE_SUB_CATEGORY2 } from '../../../constants'
import { getTermsConditionsByLocationResponse } from '../../../services/adminMasterServices'
import getCurrentUser from '../../../utils/getCurrentUser'
import { sendEmail } from '../../../services/notificationService'
import { getStationByCode } from '../../../services/searchPanelServices'
import { getDisclaimerEnabledFlag } from '../../../services/searchPanelServices'
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import leftArrow from '../../../assets/images/left-arrow.png'
import shareIcon from '../../../assets/images/Share.png'
import printIcon from '../../../assets/images/Printer.png'
import { clearItemFromSessionStorage, getBase64Encoded, getFromSessionStorage, setToSessionStorage } from '../../../utils/StorageUtils'
import FlightDetailsView from './FlightDetails'
import MilestoneNotificationDialog from '../../BookingConfirmation/MilestoneNotificationDialog';
import { getNotificationMilestone } from '../../../services/userProfileService'
import sessionKeys from '../../../constants/sessionKeys'
import { getPetDetails, getSpecializedCommodityAttachments } from '../../../services/templateService'

const BookingDetailsView = ({ awbNo, ubrNumber, setEnquiredPresent, isMutlipleBooking, toBeProcessedData }) => {
	//for multilingual
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isRTL = i18n.language === 'ar' || i18n.dir() === 'rtl';
	const [bookingDetails, setBookingDetails] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [displayPopup, setDisplayPopUp] = useState(false)
	const [disclaimerPopup, setDisclaimerPopUp] = useState(false)
	const [bookingResponse, setBookingResponse] = useState(null)
	const [fileName, setFileName] = useState('')
	const [locationCode, setLocationCode] = useState('')
	const [disclaimerFlag, setDisclaimerFlag] = useState('')
	const [disclaimerThreshold, setDisclaimerThreshold] = useState('')


	const [showCharges, setShowCharges] = useState(false)
	const [displayBasic, setDisplayBasic] = useState(false)
	const [displayPrintConfirm, setDisplayPrintConfirm] = useState(false)

	const [isPastBooking, setIsPastBooking] = useState(false)
	const [pastBookingMessage, setPastBookingMessage] = useState(false)
	const [queuedReasons, setQueuedReasons] = useState(null)
	const [showQueuedAlert, setShowQueuedAlert] = useState(false)
	const history = useHistory()

	const dgCheckNormal = getFromSessionStorage('ifDg')

	const dgSccCode = (JSON.parse(getFromSessionStorage('dgsccCode')))
	const [alertMessage, setAlertMessage] = useState('')
	const [status, setStatus] = useState(null)
	const [displayMilestonesDialog, setDisplayMilestonesDialog] = useState(false)
	const [storedMileStones, setStoredMileStones] = useState({})

	const awbNumber = `${awbNo?.trim().substring(0, 3).trim()}-${awbNo?.trim().substring(3).trim()}`

	const location = useLocation();
	const callerScreen = location.state?.callerScreen;

	const getCallerScreenUrl = () => {
		if (isMutlipleBooking) {
			return '/permanent-booking'
		} else if (callerScreen === 'ShipmentTracking') {
			return '/shipment-tracking/list'
		} else {
			return '/manage-booking/list'
		}
	}

	// const getQueueReasons = (remarks, response) => {
	// 	const reasons = []
	// 	// if (remarks.includes('NO_CAPACITY_EXCEP')) {
	// 	// 	reasons.push(t('COMMON.NO_CAPACITY_EXCEP'))
	// 	// }
	// 	if (remarks.includes('BIG_EXCEP')) {
	// 		reasons.push(t('COMMON.BIG_EXCEP'))
	// 	}
	// 	else if (remarks.includes('OHG_EXCEP')) {
	// 		reasons.push(t('COMMON.OHG_EXCEP'))
	// 	}
	// 	else if (remarks.includes('SPOT_RATE_EXCEP')) {
	// 		reasons.push(t('COMMON.SPOT_RATE_EXCEP'))
	// 	}
	// 	else if (remarks.includes('NO_RATES_EXCEP')) {
	// 		reasons.push(t('COMMON.NO_RATES_EXCEP'))
	// 	}
	// 	else if (remarks.includes('MUW_SWP_SCC_EXCEP')) {
	// 		reasons.push(t('COMMON.MUW_SWP_SCC_EXCEP'))
	// 	}
	// 	else if (remarks.includes('OTHER_EXCEP')) {

	// 		if ((dgSccCode?.includes(response?.sccCodes)) || (dgCheckNormal && dgCheckNormal === 'true')) {
	// 			// if ((msg === "SPECIALIZEDCOMMODITIES")) {
	// 			reasons.push(t('COMMON.DG_QUEUED'))
	// 			// }
	// 		}

	// 		else {
	// 			let msg = response?.shipmentDetails?.productDetails?.productName;
	// 			if ((msg === "AVI")) {
	// 				reasons.push(t('COMMON.AVI_QUEUED'))
	// 			}
	// 			else {
	// 				reasons.push(t('COMMON.OTHER_EXCEP'))
	// 			}
	// 		}

	// 	}

	// 	return reasons
	// }

	const getQueueReasons = (response) => {
        // Always compute queue reasons on the frontend using booking details
        const reasons = []
        const bookingStatus = response?.bookingStatus
        const sccCodesStr = response?.sccCodes
        const spotRateStatus = response?.spotRateStatus
        let sccList = []
        if (sccCodesStr) {
            if (Array.isArray(sccCodesStr)) {
                sccList = sccCodesStr
            } else {
                sccList = sccCodesStr.split(',').map(s => s && s.trim()).filter(Boolean)
            }
        }
        if (bookingStatus === 'Q' && sccList.length > 0) {
            if (sccList.includes('BIG')) {
                reasons.push(t('COMMON.BIG_EXCEP'))
            } else if (sccList.includes('OHG')) {
                reasons.push(t('COMMON.OHG_EXCEP'))
            } else if (spotRateStatus && (['DAT','DUA'].includes(spotRateStatus) || spotRateStatus === 'Pending Approval')) {
                reasons.push(t('COMMON.SPOT_RATE_EXCEP'))
            } else if (sccList.includes('ERR') && !response?.isRussiaBooking) {
                reasons.push(t('COMMON.NO_RATES_EXCEP'))
            } else if (sccList.includes('MUW') || sccList.includes('SWP')) {
                reasons.push(t('COMMON.MUW_SWP_SCC_EXCEP'))
            }else if ((dgSccCode?.some(code => sccList.includes(code))) || (dgCheckNormal && dgCheckNormal === 'true')) {
                    reasons.push(t('COMMON.DG_QUEUED'))
                }
			else if("AVI" === response?.shipmentDetails?.productDetails?.productName){
				reasons.push(t('COMMON.AVI_QUEUED'))
			}
			else if(response?.isRussiaBooking) {
				reasons.push(t('COMMON.RUSSIA_EXCEP'))
			}
			else{
				reasons.push(t('COMMON.OTHER_EXCEP'))
			}		
        }
        return reasons
    }
	

	useEffect(() => {
		if (history.location.state && history.location.state.modifyBooking) {
			const modifyBooking = history.location.state.modifyBooking
			setStatus(modifyBooking.status)
			if (modifyBooking.status && modifyBooking.status === true) {
				setAlertMessage(
					t(MESSAGES.MODIFY_BOOKING_SUCCESS, {
						AWB: modifyBooking.awbNo,
						status: modifyBooking.bookingStatus,
						ns: 'errors',
					})
				)
			} else {
				setAlertMessage(
					t('ER219', {
						awbNo: modifyBooking.awbNo,
						message: modifyBooking.message ? modifyBooking.message : '',
						ns: 'errors',
					})
				)
			}
			window.scrollTo(0, 0)

			let state = { ...history.location.state }
			delete state.modifyBooking
			history.replace({ ...history.location, state })
		}
	}, [history])

	useEffect(() => {
		if (bookingDetails && bookingDetails?.origin) {
			try {

				getAirportsByCode(bookingDetails?.origin).then((response) => {
					setLocationCode(response?.countryCode)
				})
			} catch (error) {
				console.log(error.message)
				return
			}
		}
	}, [bookingDetails])

	useEffect(() => {
		if (bookingDetails && bookingDetails?.origin) {
			try {

				getDisclaimerEnabledFlag(bookingDetails?.origin).then((response) => {
					setDisclaimerFlag(response?.disclaimerFeatureEnabled)
					setDisclaimerThreshold(response?.disclaimerSetThresholdInTonne)
				})
			} catch (error) {
				console.log(error.message)
				return
			}
		}
	}, [bookingDetails])
	useEffect(() => {
		if (locationCode != '') {
			locationCodeCallBack(locationCode)
		} else return
	}, [locationCode])


	const locationCodeCallBack = async () => {
		try {
			await getTermsConditionsByLocationResponse(locationCode).then(
				(response) => {
					setFileName(response?.termsAndConditions?.fileName)
				}
			)
		} catch (error) {
			console.log(error.message)
			return
		}
	}

	// useEffect(() => {
	// 	if (awbNo) {
	// 		const userDetails = getCurrentUser()
	// 		const request = {
	// 			requestId: uuidv4(),
	// 			shipmentIdentifier: getAwb(),
	// 			ubrNumber: ubrNumber,
	// 			agentCode: userDetails ? userDetails.agentCode : null,
	// 		}

	// 			; (async () => {
	// 				setIsLoading(true)
	// 				await getRecentBooking(request)
	// 					.then((response) => {
	// 						setIsLoading(false)
	// 						if (
	// 							response &&
	// 							response.bookingDetails !== null &&
	// 							response.bookingDetails !== undefined
	// 						) {
	// 							const responseBody = getBookingResponseMapper(
	// 								response.bookingDetails
	// 							)

	// 							setBookingDetails(responseBody)

	// 							setBookingResponse(response)
	// 							if (
	// 								response.bookingDetails &&
	// 								response.bookingDetails.remarks &&
	// 								response.bookingDetails.remarks.length
	// 							) {
	// 								const queuedReasons = getQueueReasons(
	// 									response.bookingDetails.remarks,
	// 									response.bookingDetails
	// 								)
	// 								//response.bookingDetails.remarks.join('')
	// 								setQueuedReasons(queuedReasons)
	// 								setTimeout(() => {
	// 									setQueuedReasons(null)
	// 								}, 4000)

	// 							}
	// 							pushPageData(
	// 								pageNames.VIEW_BOOKING,
	// 								PAGE_PRIMARY_CATEGORY.E_SERVICES,
	// 								PAGE_SUB_CATEGORY1.BOOKING,
	// 								BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
	// 							)
	// 						} else {
	// 							history.push({
	// 								pathname: getCallerScreenUrl(),
	// 								state: {
	// 									message: MESSAGES.PROCESS_REQUEST_FAILED,
	// 									success: false,
	// 								},
	// 							})
	// 							setBookingDetails(response.bookingDetails)
	// 							addError(MESSAGES.PROCESS_REQUEST_FAILED, i18n.getResource('en', 'errors', MESSAGES.PROCESS_REQUEST_FAILED))
	// 							pushPageData(
	// 								pageNames.VIEW_BOOKING,
	// 								PAGE_PRIMARY_CATEGORY.E_SERVICES,
	// 								PAGE_SUB_CATEGORY1.BOOKING,
	// 								BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
	// 							)
	// 						}
	// 						window.scrollTo(0, 0)
	// 					})
	// 					.catch((error) => {
	// 						history.push({
	// 							pathname: getCallerScreenUrl(),
	// 							state: {
	// 								// message: `${awbNo} details could not retrieve now `,
	// 								message: MESSAGES.PROCESS_REQUEST_FAILED,
	// 								success: false,
	// 							},

	// 						})
	// 						setIsLoading(false)
	// 						addError(MESSAGES.PROCESS_REQUEST_FAILED, i18n.getResource('en', 'errors', MESSAGES.PROCESS_REQUEST_FAILED))
	// 						pushPageData(
	// 							pageNames.VIEW_BOOKING,
	// 							PAGE_PRIMARY_CATEGORY.E_SERVICES,
	// 							PAGE_SUB_CATEGORY1.BOOKING,
	// 							BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
	// 						)
	// 						console.log(error)
	// 						window.scrollTo(0, 0)
	// 					})
	// 			})()
	// 	} else if (toBeProcessedData) {
	// 		const responseBody = getBookingResponseMapper(
	// 			toBeProcessedData?.bookingDetails,
	// 			true
	// 		)

	// 		setBookingDetails(responseBody)

	// 		setBookingResponse(toBeProcessedData)
	// 		if (
	// 			toBeProcessedData?.bookingDetails &&
	// 			toBeProcessedData?.bookingDetails.remarks &&
	// 			toBeProcessedData?.bookingDetails.remarks.length
	// 		) {
	// 			const queuedReasons = getQueueReasons(
	// 				toBeProcessedData?.bookingDetails?.remarks,
	// 				toBeProcessedData?.bookingDetails
	// 			)
	// 			//response.bookingDetails.remarks.join('')
	// 			setQueuedReasons(queuedReasons)
	// 			setTimeout(() => {
	// 				setQueuedReasons(null)
	// 			}, 4000)

	// 		}
	// 	}
	// }, [])

	useEffect(() => {
		if (awbNo) {
			const userDetails = getCurrentUser()
			const request = {
				messageHeader: {
					messageType: "D",
					sourceSystem: "PORTAL",
					userId: userDetails?.userId || "TESTUSER",

				},
				requestData: {
					requestID: uuidv4(),
					shipmentIdentifier: getAwb(),
					ubrNumber: ubrNumber,
					agentCode: userDetails ? userDetails.agentCode : null,
				}
			};

			(async () => {
				setIsLoading(true)
				try {
					const response = await getRecentBooking(request)

					if (
						response &&
						response.bookingDetails !== null &&
						response.bookingDetails !== undefined
					) {
						let bookingDetailsRaw = response.bookingDetails
						// Fetch pet/cage details if product is LiveAnimals
						if (bookingDetailsRaw?.productName === "AVI") {
							try {
								const petDetails = await getPetDetails(awbNumber)
								bookingDetailsRaw.cages = Array.isArray(petDetails) ? petDetails : []
							} catch (e) {
								bookingDetailsRaw.cages = []
							}
						}

						// Check if any DG SCC codes are present in the booking
						const sccCodesArray = bookingDetailsRaw?.sccCodes
							? bookingDetailsRaw.sccCodes.split(',').map(code => code.trim())
							: []
						const hasDgSccCode = sccCodesArray.some(e => dgSccCode?.includes(e))

						if (hasDgSccCode || (dgCheckNormal && dgCheckNormal === 'true')) {
							try {
								const dgAttachments = await getSpecializedCommodityAttachments(awbNumber)
								bookingDetailsRaw.specializedCommodityAttachment = Array.isArray(dgAttachments) ? dgAttachments : []
							} catch (e) {
								bookingDetailsRaw.specializedCommodityAttachment = []
							}
						}

						// check if its a Russia bound booking and fetch attachments
						if (bookingDetailsRaw.isRussiaBooking) {
							try {
								const russiaAttachments = await getRussiaAttachmentDetails(awbNumber)
								bookingDetailsRaw.russiaAttachments = Array.isArray(russiaAttachments) ? russiaAttachments : [];
							} catch (e) {
								// Handle error if needed
								bookingDetailsRaw.russiaAttachments = [];
							}
						}
						
						setIsLoading(false);
						const responseBody = getBookingResponseMapper(
							bookingDetailsRaw
						)
						setBookingDetails(responseBody)
						setBookingResponse(response)
						if (bookingDetailsRaw) {
							const queuedReasons = getQueueReasons(
								bookingDetailsRaw
							)
							setQueuedReasons(queuedReasons)
							if (queuedReasons && queuedReasons.length > 0) {
								setShowQueuedAlert(true)
								setTimeout(() => {
									setShowQueuedAlert(false)
								}, 4000)
							}
						}
						pushPageData(
							pageNames.VIEW_BOOKING,
							PAGE_PRIMARY_CATEGORY.E_SERVICES,
							PAGE_SUB_CATEGORY1.BOOKING,
							BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
						)
					} else {
						history.push({
							pathname: getCallerScreenUrl(),
							state: {
								message: MESSAGES.PROCESS_REQUEST_FAILED,
								success: false,
							},
						})
						setBookingDetails(response.bookingDetails)
						addError(MESSAGES.PROCESS_REQUEST_FAILED, i18n.getResource('en', 'errors', MESSAGES.PROCESS_REQUEST_FAILED))
						pushPageData(
							pageNames.VIEW_BOOKING,
							PAGE_PRIMARY_CATEGORY.E_SERVICES,
							PAGE_SUB_CATEGORY1.BOOKING,
							BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
						)
					}
					window.scrollTo(0, 0)
				} catch (error) {
					history.push({
						pathname: getCallerScreenUrl(),
						state: {
							message: MESSAGES.PROCESS_REQUEST_FAILED,
							success: false,
						},
					})
					setIsLoading(false)
					addError(MESSAGES.PROCESS_REQUEST_FAILED, i18n.getResource('en', 'errors', MESSAGES.PROCESS_REQUEST_FAILED))
					pushPageData(
						pageNames.VIEW_BOOKING,
						PAGE_PRIMARY_CATEGORY.E_SERVICES,
						PAGE_SUB_CATEGORY1.BOOKING,
						BOOKING_PAGE_SUB_CATEGORY2.MY_BOOKINGS
					)
					console.log(error)
					window.scrollTo(0, 0)
				}
			})()
		} else if (toBeProcessedData) {
			const responseBody = getBookingResponseMapper(
				toBeProcessedData?.bookingDetails,
				true
			)

			setBookingDetails(responseBody)

			setBookingResponse(toBeProcessedData)
			if (
				toBeProcessedData?.bookingDetails
			) {
				const queuedReasons = getQueueReasons(
					toBeProcessedData?.bookingDetails
				)
				setQueuedReasons(queuedReasons)
				if (queuedReasons && queuedReasons.length > 0) {
					setShowQueuedAlert(true)
					setTimeout(() => {
						setShowQueuedAlert(false)
					}, 4000)
				}
			}
		}
	}, [])

	useEffect(() => {

		if (!bookingDetails?.awb?.shipmentPrefix || !bookingDetails?.awb?.masterDocumentNumber) {

			return;
		}

		const fetchMilestone = async () => {
			try {
				const userDetails = getCurrentUser();

				const response = await getNotificationMilestone(
					userDetails.agentCode,
					`${bookingDetails.awb.shipmentPrefix}-${bookingDetails.awb.masterDocumentNumber}`
				);

				const modifiedResponseObj = {
					...response,
					email: response?.email?.split(','),
				};
				setStoredMileStones(modifiedResponseObj);
			} catch (error) {
				console.error("Error in fetchMilestone:", error);
			}
		};

		fetchMilestone();
	}, [bookingDetails]);



	// useEffect(() => {
	// 	const fetchMilestone = async () => {
	// 		try {
	// 			const userDetails = getCurrentUser();
	// 			console.log('userDetails', userDetails);
	// 			console.log('bookingDetails', bookingDetails);

	// 			const response = await getNotificationMilestone(userDetails.agentCode, `${bookingDetails?.awb?.shipmentPrefix}-${bookingDetails?.awb?.masterDocumentNumber}`);
	// 			const modifiedResponseObj = { ...response, email: response?.email?.split(',') }
	// 			setStoredMileStones(modifiedResponseObj)
	// 		} catch (error) {
	// 			console.error("Error in useEffect:", error);
	// 		}
	// 	};

	// 	fetchMilestone();
	// }, [bookingDetails]);



	const getAwb = () => {
		let shipmentIdentifier = {
			shipmentPrefix: awbNo.trim().substring(0, 3).trim(),
			masterDocumentNumber: awbNo.trim().substring(3).trim(),
		}
		return shipmentIdentifier
	}

	const cancelBookingDetails = async (cancelRequest) => {
		setIsLoading(true)
		await cancelBooking(cancelRequest)
			.then((response) => {
				setIsLoading(false)
				// Check for HTTP status if available
				if (response?.status && response.status !== 200) {
					setAlertMessage('We’re unable to process your request at the moment. Please try again later or contact support if the issue persists.')
					setStatus(false)
					window.scrollTo(0, 0)
					return;
				}
				// Support both old and new response structures
				const responseDetails = response?.responseDetails || response;
				const status = responseDetails?.status;
				const errorDetails = responseDetails?.errorDetails || response?.errorDetails;
				if (status === 'S') {
					history.push({
						pathname: getCallerScreenUrl(),
						state: {
							message: t('ER132', {
								AWB: awbNumber,
								ns: 'errors',
							}),
							success: true,
						},
					})

					if (disclaimerPopup) {
						handleBookingCancellation(awbNo)
					}

				} else if (errorDetails && errorDetails.length > 0) {
					history.push({
						pathname: getCallerScreenUrl(),
						state: {
							message: `${errorDetails[0].errorDescription}.`,
							success: false,
						},
					})
					addError('CANCEL_REQUEST', ` ${errorDetails[0].errorDescription}`)
				}
			})
			.catch((error) => {
				setIsLoading(false)
				setAlertMessage("We're unable to process your request at the moment. Please try again later or contact support if the issue persists.")
				setStatus(false)
				window.scrollTo(0, 0)
				addError('BOOKING_CANCELLED', error)
				console.log(error)
			})
	}

	const handleBookingCancellation = async (awbNo) => {
		const attributes = getEmailAttriburtes()
		const response = await sendEmailForAssistance(
			attributes,
			bookingDetails,
			awbNo
		)
	}
	const getEmailAttriburtes = () => {
		const userDetails = getCurrentUser()
		const attributes = [
			{
				key: 'awbNo',
				value: awbNumber,
			},
			{
				key: 'orgDst',
				value: bookingDetails ? `${bookingDetails.origin} - ${bookingDetails.destination}`
					: null,
			},
			{
				key: 'shippingDate',
				value:
					bookingDetails && bookingDetails.bookingFlightDetails && bookingDetails.bookingFlightDetails.length
						&& bookingDetails.bookingFlightDetails[0].segmentDepartureDate
						? moment(bookingDetails.bookingFlightDetails[0].segmentDepartureDate).format('DD MMM YYYY')
						: null,
			},
			{
				key: 'shippingItem',
				value:
					bookingDetails && bookingDetails.bookingCargoDetails
						? `${bookingDetails.bookingCargoDetails.commodity}-${bookingDetails.bookingCargoDetails.product}`
						: null,
			},
			{
				key: 'agentName',
				value: userDetails ? userDetails.companyName : null,
			},
			{
				key: 'agentCode',
				value: userDetails ? userDetails.agentCode : null,
			},
		]
		return attributes
	}

	const sendEmailForAssistance = async (
		attributes,
		bookingDetails,
		awbNo
	) => {
		const request = await getRequest(
			attributes,
			bookingDetails,
			awbNo
		)
		if (request) {
			const response = await sendEmail(request)
				.then((response) => {
					setIsLoading && setIsLoading(false)
					if (response.errorDetails) {
						return false
					} else {
						return true
					}
				})
				.catch((error) => {
					setIsLoading && setIsLoading(false)
					return false
				})
			return response
		} else {
			return false
		}
	}

	const getRequest = async (
		attributes,
		bookingDetails,
		awbNo
	) => {

		const userDetails = getCurrentUser()
		const stationDtls = await getStationByCode(userDetails.stationCode)
		const agentName = userDetails ? userDetails.companyName : null
		const emailDate = bookingDetails && bookingDetails.bookingFlightDetails && bookingDetails.bookingFlightDetails.length
			&& bookingDetails.bookingFlightDetails[0].segmentDepartureDate
			? moment(bookingDetails.bookingFlightDetails[0].segmentDepartureDate).format('DD MMM YYYY')
			: null
		const mailAttributes = {
			body: `${agentName ? agentName : (userDetails && userDetails.agentCode ? userDetails.agentCode : '')} has cancelled the following booking, whose chargeable weight is above set threshold for cancellation fee. Please do the needful.`,
			agentCode: userDetails ? userDetails.agentCode : null,
			agentName,
			agentEmail: userDetails ? userDetails.email : null,

		}


		if (stationDtls && stationDtls.emailAddress) {
			const emailAddresses = stationDtls.emailAddress.split(',')
			const request = {
				toEmailAddresses: emailAddresses,
				subject: `Booking Cancellation -  Above ${disclaimerThreshold} Tonne - ${`${bookingDetails.awb.shipmentPrefix}-${bookingDetails.awb.masterDocumentNumber}`} / ${emailDate}`,
				templateName: 'booking_cancellation',
				attributes: {
					...mailAttributes,
				},
				agentCode: userDetails.agentCode,
				userId: userDetails.userId,
				async: false,
			}
			if (attributes && attributes.length) {
				attributes.forEach(function (attr) {
					request.attributes[attr.key] = attr.value
				})
			}
			return request
		} else {
			return null
		}
	}

	const handleModify = () => {
		const status = checkPastBooking(bookingDetails.shippingDate)
		if (status) {
			setIsPastBooking(status)
			setPastBookingMessage(MESSAGES.ERR_MODIFY_PAST_BOOKING)
			window.scrollTo(0, 0)
		} else {
			//history.push(`/booking/modify/${awbNo}`)
			clearItemFromSessionStorage(sessionKeys.UPDATE_BOOKING_DATA)
			let additionalFlightDetails;
			const { lastAcceptanceTime, earliestDeliveryTime, dropOffAddress, pickUpAddress } = bookingDetails || {}
			if (lastAcceptanceTime || earliestDeliveryTime || dropOffAddress || pickUpAddress) {
				additionalFlightDetails = {
					lastAcceptanceTime: lastAcceptanceTime || null,
					earliestDeliveryTime: earliestDeliveryTime || null,
					dropOffAddress: dropOffAddress || null,
					pickUpAddress: pickUpAddress || null
				}
			}
			const initialAWBData = {
				origin: bookingDetails.origin,
				destination: bookingDetails.destination,
				shippingDate: bookingDetails.shippingDate,
			}
			setToSessionStorage(sessionKeys.UPDATE_BOOKING_DATA, getBase64Encoded({ awbFlightDetails: bookingDetails?.bookingFlightDetails, additionalFlightDetails, initialAWBData }))
			if (callerScreen === 'ShipmentTracking') {
				history.push(`/booking/modify/${awbNo}`, { callerScreen: "ShipmentTracking" })
			} else {
				history.push(`/booking/modify/${awbNo}`)
			}

		}
	}

	const handleDisplayPopUp = () => {
		const status = checkPastBooking(bookingDetails.shippingDate)
		if (status) {
			setIsPastBooking(status)
			setPastBookingMessage(MESSAGES.ERR_CANCEL_PAST_BOOKING)
			window.scrollTo(0, 0)
		} else if (bookingDetails.bookingStatus == "C" && bookingDetails.chargeDetails.chargeableWeight
			&& disclaimerFlag == "Y"
			&& Number(bookingDetails.chargeDetails.chargeableWeight.replace(',', '')) >= (Number(disclaimerThreshold) * 907.185)) {
			setDisclaimerPopUp(true)
		} else {
			setDisplayPopUp(true)
		}
	}

	const handleBookingCancel = () => {
		const userDetails = getCurrentUser();
		const cancelRequest = {
			messageHeader: {
				messageType: "D",
				sourceSystem: "PORTAL",
				userId: userDetails?.userId,
				messageID: uuidv4(),
				correlationID: uuidv4()
			},
			source: "PORTAL",
			userId: userDetails?.userId,
			requestData: {
				requestID: uuidv4(),
				operationalFlag: "D",
				bookingDetailsFilter: {
					shipmentIdentifierDetails: getAwb(),
				},
			},
		}
		cancelBookingDetails(cancelRequest)
		//handleBookingCancellation(awbNo)
	}

	const handleBack = () => {
		history.push({
			pathname: getCallerScreenUrl(),
			state: {
				retainFormData: true,
			},
		})

		window.scrollTo(0, 0)
	}

	const onClickShare = () => {
		setDisplayBasic(true)
	}

	const printDetails = () => {
		handlePrint(bookingDetails, showCharges, setIsLoading)
	}

	const checkPastBooking = (shippingDate) => {
		const today = moment()
		return (
			shippingDate && moment(shippingDate, 'ddd DD MMM', 'en', true).isSameOrBefore(today, 'day')
		)
	}

	const handleAlertClose = () => {
		setIsPastBooking(false)
		setPastBookingMessage('')
	}

	const handleAlertClose1 = () => {
		setStatus(null)
		setAlertMessage('')
	}

	const getBookingStatusIcon = () => {
		let icon = null
		if (toBeProcessedData) {
			icon = toBeProcessedIcon
		} else if (bookingDetails.bookingStatus === 'C') {
			icon = successIcon
		} else if (bookingDetails.bookingStatus === 'Q') {
			icon = pendingIcon
		} else if (bookingDetails.bookingStatus === 'X') {
			icon = rejectIcon
		}
		return icon ? <img
			className='status-icon'
			alt={`status-icon-${bookingDetails.bookingStatus}`}
			src={icon}
		/> : <></>
	}


	const onClickNotify = () => {
		setDisplayMilestonesDialog(true)
	}

	return (
		<div id='bookingDetails' className={`booking-details ${isRTL ? 'rtl' : ''}`}>
			{isLoading ? <LoadingIndicator /> : <></>}
			<BookingMenu activeItem={isMutlipleBooking ? 5 : 1} />
			<ShareEmailDialog
				bookingDetails={bookingDetails}
				displayBasic={displayBasic}
				setDisplayBasic={setDisplayBasic}
			/>
			<MilestoneNotificationDialog
				awbNumber={awbNumber}
				displayBasic={displayMilestonesDialog}
				setDisplayBasic={setDisplayMilestonesDialog}
				storedMilestones={storedMileStones}
				setStoredMilestones={setStoredMileStones}
			/>
			{alertMessage !== '' && status !== null && (
				<Alert
					isError={!status}
					showAlert={true}
					message={t(alertMessage, { ns: 'errors' })}
					setTimeout={true}
					onAlertClose={handleAlertClose1}
				/>
			)}
			{isPastBooking && (
				<Alert
					type={NOTIFICATION_MESSAGE_TYPE.INFO}
					showAlert={true}
					message={t(pastBookingMessage, { ns: 'errors' })}
					setTimeout={true}
					onAlertClose={handleAlertClose}
				/>
			)}
			{showQueuedAlert && queuedReasons && queuedReasons.length > 0 && (
				<Alert
					type={NOTIFICATION_MESSAGE_TYPE.WARNING}
					showAlert={true}
					message={queuedReasons}
					setTimeout={false}
					onAlertClose={handleAlertClose}
				/>
			)}

			{/* <div className='form-row'>
				<div className='col-12 col-lg-12'>
					<h3 className=' page-heading pl-0 pt-0'>
						{t('VIEWBKG.BOOKING_DETAILS')}
					</h3>
				</div>
			 </div> */}
			<div className='booking-details-view-wrapper'>
				<div className='booking-view-heading-section'>
					<div className='form-row align-items-center mb-0'>
						<div className='col-12 col-lg-12'>
							{/* Back Button with left arrow icon */}
							<button
								type="button"
								className="icon-btn d-flex align-items-center manage-booking-back-btn"
								onClick={handleBack}
							>
								<img
									src={leftArrow}
									alt="Back"
									className='left-arrow-btn'
								/>
								<span className='left-arrow-btn-text'>{t('COMMON.BACK_BUTTON')}</span>
							</button>
						</div>
					</div>

					<div className='form-row align-items-center'>
						<div className='col-12 col-lg-12 d-flex align-items-center justify-content-between'>
							<h3 className='page-heading pl-0 pb-0 pt-0 mb-0 mt-0'>
								{t('VIEWBKG.BOOKING_DETAILS')}
							</h3>
							<div className="d-flex align-items-center">
								{!(isMutlipleBooking && toBeProcessedData) && (
									<>
										<button
											type="button"
											className="icon-btn d-flex align-items-center mr-2"
											onClick={onClickShare}
										>
											<img
												src={shareIcon}
												alt="Share"
												style={{ width: 22, height: 22 }}
											/>
										</button>
										<button
											type="button"
											className="icon-btn d-flex align-items-center"
											onClick={() => {
												setDisplayPrintConfirm(!displayPrintConfirm)
												setShowCharges(false)
											}}
										>
											<img
												src={printIcon}
												alt="Print"
												style={{ width: 22, height: 22 }}
											/>
										</button>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
				{bookingDetails !== null ? (
					bookingDetails.length === 0 ? (
						<div className='no-data ml-0 mr-0'>
							{t(MESSAGES.LOADING, { ns: 'errors' })}
						</div>
					) : (
						<div className='view-booking-details-section'>
							{/* <div
							className='form-row primary-details-wrapper'
							id='primary-details-wrapper'
						 >
							<div className='col-10 awb-wrapper'>
								{bookingDetails.awb && (
									<span className='d-block d-lg-inline'>
										{t('COMMON.AWB_NUMBER')} :{' '}
										{bookingDetails.awb.shipmentPrefix}-
										{bookingDetails.awb.masterDocumentNumber}
									</span>
								)}

								<span className='pl-3 pr-3 d-none d-lg-inline'>|</span>
								<span>
									{bookingDetails.origin} - {bookingDetails.destination}
								</span>
								<span className='pl-1 pr-1 pl-lg-3 pr-lg-3'>|</span>
								<span>{bookingDetails.shippingDate} </span>
								<span className='pl-lg-3 pr-lg-3'></span>
								<span
									className={`status-wrapper d-block d-lg-inline ${bookingDetails.bookingStatus === 'C'
										? 'status-confirmed confirm-tick-mark'
										: bookingDetails.bookingStatus === 'Q'
											? 'status-queued'
											: ''
										}`}
								>
									{bookingDetails.bookingStatus === 'Q' && (
										<i className='pr-2 indicator'>
											<img
												src={pendingIcon}
												alt='pending'
												className='image-wrapper pl-0 pb-1'
											></img>

										</i>
									)}

									{bookingDetails.bookingStatus === 'X' && (
										<i>
											<img
												src={rejectIcon}
												alt='Rejected'
												className='image-wrapper pl-0 pb-1'
											></img>
										</i>
									)}
									<span>{t(BOOKING_STATUSES[bookingDetails.bookingStatus])}</span>
								</span>
							</div>
							{bookingDetails.bookingStatus &&
								bookingDetails.bookingStatus !== 'X' && (
									<div className='col-2 text-right pt-3 pt-lg-0'>
										<span
											className='link d-none d-lg-inline'
											onClick={handleModify}
										>
											{t('COMMON.MODIFY')}
										</span>
										<span
											className='primary-details-wrapper_modify-mobile d-lg-none d-inline'
											onClick={handleModify}
										>
											<img
												src={editIcon}
												alt='modify-mobile'
												title='modify-mobile'
											/>
										</span>
									</div>
								)}
						</div> */}

							<div className="form-row primary-details-wrapper booking-details-card" id="primary-details-wrapper">
								{/* Status Wrapper - first line */}
								<div className="status-row">
									{getBookingStatusIcon()}
									<span className='status-content'>
										<>
											<div className='main-label'>
												{toBeProcessedData ? t('EXTRAS.TO_BE_PROCESSED') : <>{t('BOOKING.YOUR_BOOKING')} {t(BOOKING_STATUSES[bookingDetails.bookingStatus])}</>}
											</div>
											<div className='sub-label'>
												{toBeProcessedData
													? t('BOOKING.TBP_LABEL')
													: queuedReasons && queuedReasons.length > 0
														? queuedReasons.join(', ')
														: ''}
											</div>
										</>
									</span>
								</div>

								{/* Details - second line */}
								<div className="details-row d-flex flex-row align-items-stretch justify-content-start">
									{/* AWB Number */}
									<div className="details-col">
										<span className={`details-heading ${i18n.language === 'es' ? 'details-heading--spanish-mobile' : ''}`}>
											{t('COMMON.AWB_NUMBER')}
										</span>
										<span className="details-data">
											{bookingDetails.awb
												? `${bookingDetails.awb.shipmentPrefix}-${bookingDetails.awb.masterDocumentNumber}`
												: '- -'}
										</span>
									</div>
									{/* Separator */}
									<div className="details-separator"></div>
									{/* Origin - Destination */}
									<div className="details-col">
										{/* Desktop view */}
										<span className="details-heading d-none d-lg-inline">
											{t('CHOOSE_FLT.ORGIN_DESTINATION')}
										</span>
										{/* Mobile view */}
										<span className={`details-heading d-inline d-lg-none ${i18n.language === 'es' ? 'details-heading--spanish-mobile' : ''}`}>
											{t('CHOOSE_FLT.ORGIN_DESTINATION_MOBILE')}
										</span>
										<span className="details-data">
											{bookingDetails.origin && bookingDetails.destination
												? `${bookingDetails.origin} - ${bookingDetails.destination}`
												: ' '}
										</span>
									</div>
									{/* Separator */}
									<div className="details-separator"></div>
									{/* Shipping Date */}
									<div className="details-col">
										<span className={`details-heading ${i18n.language === 'es' ? 'details-heading--spanish-mobile' : ''}`}>
											{t('COMMON.SHP_DATE')}
										</span>
										<span className="details-data">
											{bookingDetails.shippingDate || ' '}
										</span>
									</div>
								</div>

								{/* Modify button (if applicable) */}
								{/* {bookingDetails.bookingStatus && bookingDetails.bookingStatus !== 'X' && (
									<div className="col-12 text-right pt-3 pt-lg-0">
										<span
											className="link d-none d-lg-inline"
											onClick={handleModify}
											style={{ cursor: 'pointer' }}
										>
											{t('COMMON.MODIFY')}
										</span>
										<span
											className="primary-details-wrapper_modify-mobile d-lg-none d-inline"
											onClick={handleModify}
											style={{ cursor: 'pointer' }}
										>
											<img
												src={editIcon}
												alt="modify-mobile"
												title="modify-mobile"
											/>
										</span>
									</div>
								)} */}
							</div>
							<div>
								<div className='d-flex align-items-center justify-content-between cargo-details-header'>
									<h3 className='page-sub-head-view-booking mb-1'>{t('COMMON.CARGO_DTLS')}</h3>
									{!isMutlipleBooking && bookingDetails.bookingStatus !== 'X' && !bookingDetails.isAwbDataCaptureDone &&
										<div
											className='cargo-edit-link'
											onClick={handleModify}
										>
											<span>{t('COMMON.EDIT')}</span>
										</div>
									}
								</div>
								<CargoDetails bookingDetails={bookingDetails} />
							</div>

							{/* <WeightDetails bookingDetails={bookingDetails} /> */}

							<FlightDetailsView
								bookingDetails={bookingDetails}
								bookingResponse={bookingResponse}
								setIsLoading={setIsLoading}
								awbNo={awbNo}
								setIsPastBooking={setIsPastBooking}
								setPastBookingMessage={setPastBookingMessage}
								isMutlipleBooking={isMutlipleBooking}
								toBeProcessedData={toBeProcessedData}
							/>

							{!toBeProcessedData ? <ChargeDetails bookingDetails={bookingDetails} /> : <></>}

							<div className='form-row cancel-button-row'>
								<div className='footer-button'>
									{(!isMutlipleBooking && bookingDetails.bookingStatus !== 'X') && (
										<button
											type='button'
											className='secondary-button'
											onClick={onClickNotify}
										>
											{t("COMMON.NOTIFY")}
										</button>
									)}
								</div>
								{bookingDetails.bookingStatus &&
									bookingDetails.bookingStatus !== 'X' && [undefined, null].includes(toBeProcessedData) && (
										<div className=' cancel-button-mobile d-lg-none '>
											<button className='cancel-booking-button' onClick={handleDisplayPopUp}>
												{t('BKGCAN.CANCEL_BOOKING')}
											</button>
										</div>
									)}
								{/* <div className='col-12 col-lg-8 mt-5'>
								<div className='form-row footer-buttons-session'>
									<div className='footer-button'>
										<button
											type='button'
											className='secondary-button'
											onClick={handleBack}
										>
											{t('COMMON.BACK_BUTTON')}
										</button>
									</div>
									<div className='footer-button'>
										<button
											type='button'
											className='primary-button'
											onClick={onClickShare}
										>
											{t('COMMON.SHARE')}
										</button>
									</div>

									<div className='footer-button'>
										<button
											type='button'
											className='primary-button'
											onClick={(e) => {
												setDisplayPrintConfirm(!displayPrintConfirm)
												setShowCharges(false)
											}}
										>
											{t('COMMON.PRINT')}
										</button>
									</div>
									<div className='footer-button'>

										<button
											type='button'
											className='secondary-button'
											onClick={onClickNotify}
										>
											Notify
										</button>
									</div>
								</div>
							</div> */}
								{bookingDetails.bookingStatus &&
									bookingDetails.bookingStatus !== 'X' && [undefined, null].includes(toBeProcessedData) && (
										<div className='text-right d-none d-lg-inline'>
											<button className='cancel-booking-button' onClick={handleDisplayPopUp}>
												{t('BKGCAN.CANCEL_BOOKING')}
											</button>
										</div>
									)}
							</div>
						</div>
					)
				) : (
					<div className='no-data ml-0 mr-0'>
						{' '}
						Sorry, the booking detail is not available.
					</div>
				)}
			</div >
			{displayPrintConfirm && (
				<PrintBookingDialog
					showCharges={showCharges}
					setShowCharges={setShowCharges}
					displayPrintConfirm={displayPrintConfirm}
					setDisplayPrintConfirm={setDisplayPrintConfirm}
					printDetails={printDetails}
				/>
			)}
			{
				displayPopup ? (
					<CancelBookingModal
						displayPopUp
						setDisplayPopUp={setDisplayPopUp}
						// content={t(MESSAGES.POP_UP_CANCEL_TEXT, { AWB: awbNo, ns: 'errors' })}
						content={
							<Trans
								i18nKey={MESSAGES.POP_UP_CANCEL_TEXT}
								ns="errors"
								values={{
									AWB: awbNo
										? `${awbNo.substring(0, 3)}-${awbNo.substring(3)}`
										: '',
								}}
								components={{
									AWB: (
										<span className='cancel-awb-number' />
									),
								}}
							/>
						}
						onCancelBooking={handleBookingCancel}
					/>
				) : (
					<></>
				)
			}

			{
				disclaimerPopup && fileName && fileName !== '' ? (

					<ConfirmationPopUp
						displayPopUp
						headerText={t('COMMON.CANCELING_BOOKING')}
						setDisplayPopUp={setDisclaimerPopUp}
						message=

						{fileName && fileName !== '' ? (
							<React.Fragment>
								<Trans
									i18nKey={t('ER238', { ns: 'errors' })}

									t={t}
									components={[
										<a
											className='link terms-conditions-wrapper__link '
											href={
												fileName && fileName.length
													? `/media/${fileName}`
													: '/'
											}
											role='button'
											target='_blank'
											rel='noreferrer'
										>
											{' '}
										</a>,
									]}
								/>
							</React.Fragment>
						)
							:
							(
								<React.Fragment>
									{t('MESSAGES.DISCLAIMER_TEXT')}
								</React.Fragment>
							)}

						primaryBtnLbl={t('COMMON.YES')}
						secondaryBtnLbl={t('COMMON.NO')}
						acceptFn={handleBookingCancel}
					/>
				) : (
					<></>
				)
			}

		</div >
	)
}

export default BookingDetailsView
